import 'core-js/stable'
import "regenerator-runtime/runtime";

import Vue from 'vue'
import Vuetify from 'vuetify'
// import {
//     VCard,
//     VRating,
//     VSlider,
//     VToolbar,
// } from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css'
// import { Ripple } from 'vuetify/lib/directives'


Vue.use(Vuetify, {
    components: {

    },
    directives: {}
})

export default new Vuetify({
    breakpoint: {
        thresholds: {
            xs: 340,
            sm: 540,
            md: 1486,
            lg: 1644,
            xl: 1920
        }
    }
})